import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';

@Component({
    selector: 'app-dialog-basic',
    templateUrl: './dialog-basic.component.html',
    styleUrls: ['./dialog-basic.component.scss'],
    changeDetection: ChangeDetectionStrategy.Default
})
export class DialogBasicComponent implements OnInit {

    title: string;
    description: string;
    yesBtn = 'Да';
    noBtn = 'Нет';

    constructor(public dialogRef: NbDialogRef<DialogBasicComponent>) {
    }

    ngOnInit(): void {
    }

    accept() {
        this.dialogRef.close(true);
    }

    decline() {
        this.dialogRef.close();

    }
}
